import { useCallback, useEffect, useRef, useState } from 'react';

export function useHeldHeight(holding: boolean) {
  const [heldHeight, setHeldHeight] = useState(0);
  const holdingRef = useRef(holding);
  const observerRef = useRef<ResizeObserver | null>(null);

  useEffect(() => {
    holdingRef.current = holding;
    if (!holding) {
      setHeldHeight(0);
    }
  }, [holding]);

  useEffect(() => () => observerRef.current?.disconnect(), []);

  const ref = useCallback((node: HTMLElement | null) => {
    observerRef.current?.disconnect();
    observerRef.current = null;
    if (!node || typeof ResizeObserver === 'undefined') {
      return;
    }
    observerRef.current = new ResizeObserver(() => {
      if (holdingRef.current) {
        setHeldHeight((previous) => Math.max(previous, node.offsetHeight));
      }
    });
    observerRef.current.observe(node);
  }, []);

  return { ref, minHeight: holding && heldHeight > 0 ? heldHeight : undefined };
}
